'use client'

import { useUserPortfolio } from '@repo/services'
import { useTranslate } from '@repo/shared/hooks'
import {
  Card,
  Skeleton,
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from '@repo/ui/components'
import { WalletProjectPropertyCards } from './wallet-project-property.cards'
import { WalletProjectCards } from './wallet-project.cards'
import { WalletCards } from './wallet.cards'
import type { Asset } from './wallet.types'
export const WalletContainer = () => {
  const { t } = useTranslate()
  const tabs = [
    {
      value: 'tokens',
      label: t('walletPage_tokens'),
    },
    {
      value: 'projects',
      label: t('walletPage_projects'),
    },
  ]
  const {
    data: { data: { accounts = [], projects = [], ledgers = [] } = {} } = {},
    isFetched,
  } = useUserPortfolio()

  const wallets: Asset[] = (accounts || [])
    .filter((account) => account.type !== 'project')
    .map((account, index) => ({
      id: `${'account'}-${index}`,
      title:
        account.type === 'fiat' && account.currency === 'IRR'
          ? t('walletPage_toman_balance')
          : account.type === 'asset' && account.currency === 'MALEK'
            ? t('walletPage_malek_balance')
            : (account.currency ?? ''),
      amount: account.estimatedBalance ?? 0,
      assetAmount: account.availableBalance ?? 0,
      unit: account.currency ?? '',
      scale:
        (account.currency === 'IRR'
          ? 10
          : ledgers?.find((ledger) => ledger.name === account.currency)
              ?.scale) ?? 1,
      icon:
        account.type === 'fiat' && account.currency === 'IRR'
          ? 'Tmn'
          : undefined,
      type: account.type,
      href:
        account.type === 'asset' && account.currency === 'MALEK'
          ? `/history/balance/asset/${account.currency}`
          : `/history/balance`,
    }))

  const userProjects = (accounts || []).filter(
    (account) => account.type === 'project',
  )

  const sortedWallets = wallets.sort((a, b) => {
    if (a.type === 'fiat' && b.type === 'asset') return -1
    if (a.type === 'asset' && b.type === 'fiat') return 1
    return 0
  })

  return (
    <div className='flex flex-col md:flex-row max-w-container-md mx-auto gap-md'>
      <Card withoutBorder className='w-full mb-9xl md:mb-0 p-md'>
        <Tabs defaultValue='tokens' color='base' size='md' scrollable={false}>
          <TabsList className='w-full md:w-fit'>
            {tabs.map((tab) => (
              <TabsTrigger key={tab.value} value={tab.value}>
                {tab.label}
              </TabsTrigger>
            ))}
          </TabsList>
          {!isFetched ? (
            <>
              <Skeleton className='w-full h-7xl' />
              <Skeleton className='w-full h-7xl' />
              <Skeleton className='w-full h-10xl' />
              <Skeleton className='w-full h-10xl' />
            </>
          ) : (
            tabs.map((tab) => (
              <TabsContent key={tab.value} value={tab.value}>
                {tab.value === 'tokens' && (
                  <>
                    <WalletCards
                      wallets={sortedWallets}
                      isLoading={!isFetched}
                    />
                    <WalletProjectCards
                      projects={projects || []}
                      userProjects={userProjects}
                      isLoading={!isFetched}
                    />
                  </>
                )}
                {tab.value === 'projects' && (
                  <WalletProjectPropertyCards
                    projects={projects || []}
                    userProjects={userProjects}
                    isLoading={!isFetched}
                  />
                )}
              </TabsContent>
            ))
          )}
        </Tabs>
      </Card>
    </div>
  )
}
